import * as services from '@api';
import { goBack } from '../navigate';
import { requiredValidate, BillStatusType } from '../utils';
import { PageStatusType } from '@stores/pagestore';
import request from 'ynf-core-engine/request';
const MDF_PATH = '/mdf-node/qtmProxy'

/**
 * 提交
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  cardStoreKey: string， 默认值：cardStore
 *  // 选填字段
 *  dataSourceAlias: string， 默认值：cardStore.dataSource
 *  billNo: string， 默认值：params.billNo
 *  billId: string， 默认值：params.billId
 * }
 * @returns
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const submit = {
  async doAction(rootStore: any, options: any = {}) {
    requiredValidate.call(this, options, ['cardStoreKey']);
    const { dataSourceAlias = '', cardStoreKey = 'cardStore', successTips } = options;
    const { utils = {}, pageStore = {} } = rootStore;
    const { params = {}, query = {} } = pageStore;
    const cardStore = rootStore.get(cardStoreKey);
    if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));
    const data = cardStore.getValue();

    try {
      pageStore?.startLoading?.()
      const mode = cardStore.uiState || pageStore.status;
      const submitData = {
        data: JSON.stringify(data)
      }
      // res是判断是否有指派
      let res = await assignCheck(rootStore, options)
      if (res) {
        pageStore?.endLoading?.()
        // 有指派就调用选人弹窗
        res = await assignCheckModal(rootStore, res)
        if (!res) {
          // 弹窗出问题就报错
          console.error('审批指派弹窗出问题')
          return
        }
        submitData.assignInfo = {
          assignInfoItems: res
        }
        pageStore?.startLoading?.()
      }
      const submitRes = await services.submit({
        params: {
          ...query,
          datasource: dataSourceAlias || cardStore?.dataSource || '',
          billnum: options.billNo || params.billNo,
          billId: options.billId || params.billId,
          busiObj: options.busiObj || query.busiObj,
          mode
        },
        data: submitData
      })
      cardStore.setValue(submitRes.data, { merge: true });
      cardStore.setUiState(PageStatusType.BROWSE);
      utils.message.success(successTips || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80067', '提交成功'))
      return submitRes;
    } catch (err: any) {
      utils.message.danger(err?.message)
      return Promise.reject(err)
    } finally {
      pageStore?.endLoading?.()
    }
  }
}

/**
 * 撤回
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  cardStoreKey: string， 默认值：cardStore
 *  // 选填字段
 *  dataSourceAlias: string， 默认值：cardStore.dataSource
 *  billNo: string， 默认值：params.billNo
 *  billId: string， 默认值：params.billId
 * }
 * @returns
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const unsubmit = {
  async doAction(rootStore: any, options: any = {}) {
    requiredValidate.call(this, options, ['cardStoreKey']);
    const { dataSourceAlias = '', cardStoreKey = 'cardStore', successTips } = options;
    const { utils = {}, pageStore = {} } = rootStore;
    const { params = {}, query = {} } = pageStore;
    const cardStore = rootStore.get(cardStoreKey);
    if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));
    const data = cardStore.getValue();
    
    try {
      pageStore?.startLoading?.()
      const mode = cardStore.uiState || pageStore.status;
      const unsubmitRes = await services.unsubmit({
        params: {
          ...query,
          datasource: dataSourceAlias || cardStore?.dataSource || '',
          billnum: options.billNo || params.billNo,
          billId: options.billId || params.billId,
          busiObj: options.busiObj || query.busiObj,
          mode
        },
        data: {
          billnum: '',
          data: JSON.stringify(data)
        }
      })
      cardStore.setValue(unsubmitRes.data, { merge: true });
      cardStore.setUiState(PageStatusType.BROWSE);
      utils.message.success(successTips || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80066', '撤回成功'));
      return unsubmitRes;
    } catch (err: any) {
      utils.message.danger(err?.message);
      return Promise.reject(err)
    } finally {
      pageStore?.endLoading?.()
    }
  }
}

async function assignCheck(rootStore: any, options: any = {}) {
  const { dataSourceAlias = '', pageStore = {}, cardStoreKey = 'cardStore' } = rootStore;
  const { params = {}, query = {} } = pageStore
  const cardStore = rootStore.get(cardStoreKey);
  try {
    const data = cardStore.getValue()
    const res = await services.assignCheck({
      params: {
        ...query,
        datasource: dataSourceAlias || cardStore?.dataSource || '',
        busiObj: options.busiObj || params?.busiObj || query.busiObj || '',
        sbillno: params?.billNo || '',
      },
      data: {
        billnum: params?.billNo || '',
        data
      }
    });
    if (res?.data?.assignAble) {
      return res.data
    }
    return false
  } catch (err: any) {
    console.error(err);
    return false;
  }
}

async function assignCheckModal(rootStore: any, assignInfoData: any) {
  const { cardStoreKey = 'cardStore' } = rootStore;
  const cardStore = rootStore.get(cardStoreKey);
  const formStore = cardStore?.formStore || 'formStore'
  const form = rootStore.get(formStore)
  try {
    // 指派和审批用的使用的都是审批中心的js，flowJsLoaded是判断审批js是否完全加载完毕
    if (form.workFlowStore.flowJsLoaded) {
      // 唤起指派弹窗的方法
      if (rootStore.isPc) {
        const res = await form.workFlowStore.renderAssigneeNew(assignInfoData)
        return res
      } else {
        const res = await form.workFlowStore.showAssignCheck(assignInfoData)
        return res
      }
    } else {
      console.error('审批js还没准备好');
    }
    return false;
  } catch (err: any) {
    console.error(err);
    return false;
  }
}


